const loginBtn = document.querySelectorAll(".SSO_popup_login");  // simple login
	const registerBtn = document.querySelectorAll(".SSO_popup_register");  // cc register
	const eliteJoinBtn = document.querySelectorAll(".SSO_popup_elite_join"); // elite register
	const eliteUpgradeBtn = document.querySelectorAll(".SSO_popup_elite_upgrade"); // cc to elite memeber


	const popup = document.getElementById('new_popup-modal2');
	const close_popup = document.querySelector('#new_popup-modal2 .close_popup');
	const overlay = document.getElementById('new_popup-overlay2');


	const mainLoginForm = document.querySelector('.main_login_form')
	const mainSignupForm = document.querySelector('.main_signup_form') 
	const mainSignupEliteForm = document.querySelector('.main_elite_signup_form') 
	const mainEliteUpgradeForm = document.querySelector('.main_elite_upgrade_form') 


	if (!localStorage.getItem('popupClosed') ) { 
		setTimeout(() => { 
			if(localStorage.getItem('popupClosed') != 'true'){
				openPopup2('signup_form') 
			} 
		}, 3000);
	}

	const closePopup2 = function (firstTime = false) {
		popup.style.display = 'none';
		overlay.style.display = 'none';  

		if(firstTime) localStorage.setItem('popupClosed', 'true')
	};


	
	openPopup2 = function (form) {
		if(form == 'login_form'){
			document.querySelectorAll('.new_forms').forEach(f=>f.classList.add('new_hidden'))
			mainLoginForm.classList.remove('new_hidden')
		}else if(form == 'signup_form'){
			document.querySelectorAll('.new_forms').forEach(f=>f.classList.add('new_hidden'))
			mainSignupForm.classList.remove('new_hidden')
		}else if( form == 'signup_elite_form'){
			document.querySelectorAll('.new_forms').forEach(f=>f.classList.add('new_hidden'))
			mainSignupEliteForm.classList.remove('new_hidden')
		}else if( form == 'signup_upgrade_form'){
			document.querySelectorAll('.new_forms').forEach(f=>f.classList.add('new_hidden'))
			mainEliteUpgradeForm.classList.remove('new_hidden')
		}

		popup.style.display = 'block';
		overlay.style.display = 'block';  
	}; 


	overlay.addEventListener('click',function(){
		if (!localStorage.getItem('popupClosed') || localStorage.getItem('popupClosed') != 'true'){
			closePopup2(true)
		}else{
			closePopup2()
		}
	})
	close_popup.addEventListener('click',function(){
		if (!localStorage.getItem('popupClosed') || localStorage.getItem('popupClosed') != 'true'){ 
			closePopup2(true)
		}else{
			closePopup2()
		}
	})



	loginBtn.forEach((btn) => {
		btn.addEventListener("click", () => {
			openPopup2('login_form')
		});
	});

	registerBtn.forEach((btn) => {
		btn.addEventListener("click", () => {
			openPopup2('signup_form')
		});
	});

	eliteJoinBtn.forEach((btn) => {
		btn.addEventListener("click", () => {
			openPopup2('signup_elite_form')
		});
	});

	eliteUpgradeBtn.forEach((btn) => {
		btn.addEventListener("click", () => {
			openPopup2('signup_upgrade_form')
		});
	});